
import React from "react";
import Header from "./Header/header";
import Main from "./Main/main";

function Equipments() {
  return (
    <div>
      <Header />
      <Main />
    </div>
  );
}

export default Equipments;
